import { useState, useCallback } from 'react';
import { loadDmPartyDefaults, saveDmPartyDefaults, normalizeDmPartyDefaults } from '../utils/dmPartyDefaults';

/**
 * Persisted DM party size/level for encounter math when no PC leveled friendlies exist.
 */
export function useDmPartyDefaults() {
  const [party, setPartyState] = useState(() => loadDmPartyDefaults());

  const setParty = useCallback((next) => {
    setPartyState((prev) => {
      const merged =
        typeof next === 'function'
          ? next(prev)
          : { ...prev, ...(next && typeof next === 'object' ? next : {}) };
      const normalized = normalizeDmPartyDefaults(merged);
      saveDmPartyDefaults(normalized);
      return normalized;
    });
  }, []);

  return [party, setParty];
}
